import { Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, Input, Output,} from "@angular/core";
import { CommonModule } from "@angular/common";
import { TranslatePipe } from "@loup-transload-ui-app/common-pipes";

@Component({
  standalone: true,
  selector: 'lib-rate-provisions-overlay',
  templateUrl: './rate-provisions-overlay.component.html',
  styleUrls: ['./rate-provisions-overlay.component.scss'],
  imports: [CommonModule,TranslatePipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})

export class RateProvisionsOverlayComponent  {
@Input() provisionsList: any = [];
@Input() isOverlayOpen = false;
@Input() isExternal = false;
@Output() updateFlagStatus = new EventEmitter();

closeOverlay() {
    this.isOverlayOpen = false;
    this.updateFlagStatus.emit();
  }
}